import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function SuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set premium member flag in localStorage
    localStorage.setItem('premium_member', 'true');
    
    // Optional: You can also store the subscription details
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      localStorage.setItem('stripe_session_id', sessionId);
    }
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-8 animate-bounce">
            <i className="ri-check-line text-5xl text-white"></i>
          </div>

          {/* Success Message */}
          <h1 className="text-4xl font-bold text-white mb-4">
            Welcome to Premium!
          </h1>
          
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Your payment was successful. You now have full access to all loan guidelines and premium features.
          </p>

          {/* Features List */}
          <div className="bg-slate-800 rounded-xl border border-slate-700 p-8 mb-8 max-w-2xl mx-auto">
            <h2 className="text-2xl font-semibold text-white mb-6">What You Get:</h2>
            <ul className="space-y-4 text-left">
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">Access to all 40+ comprehensive loan guidelines</span>
              </li>
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">County assessor directory for all states</span>
              </li>
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">Download guidelines as PDF documents</span>
              </li>
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">Bookmark and save your favorite guidelines</span>
              </li>
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">Priority customer support</span>
              </li>
              <li className="flex items-start text-slate-300">
                <i className="ri-check-line text-emerald-400 text-2xl mr-3 mt-0.5 flex-shrink-0"></i>
                <span className="text-lg">Regular updates and new content</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={() => navigate('/')}
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg hover:bg-emerald-500 font-semibold text-lg cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-home-line mr-2"></i>
              Browse Guidelines
            </button>
            <button
              onClick={() => navigate('/assessor-directory')}
              className="bg-slate-700 text-slate-300 px-8 py-4 rounded-lg hover:bg-slate-600 font-semibold text-lg cursor-pointer whitespace-nowrap transition-colors border border-slate-600"
            >
              <i className="ri-map-pin-line mr-2"></i>
              View Assessor Directory
            </button>
          </div>

          {/* Additional Info */}
          <div className="bg-teal-900/30 border border-teal-600/50 rounded-lg p-6 max-w-2xl mx-auto">
            <p className="text-teal-200">
              <i className="ri-information-line mr-2"></i>
              A confirmation email has been sent to your inbox with your subscription details.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
